var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "meta 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "meta"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 878",
    d: "M20.0588 11.3306C21.3273 10.4862 22.6749 9.97266 24.1189 9.97266C28.1788 9.97266 30.2087 16.0626 30.2087 20.1225C30.2087 24.1825 28.1788 26.2124 26.1488 26.2124C21.0738 26.2124 15.9989 9.97266 7.87898 9.97266C3.81904 9.97266 1.78906 16.0626 1.78906 20.1225C1.78906 24.1825 3.81904 26.2124 5.84901 26.2124C7.95955 26.2124 10.0701 23.4038 12.3996 20.1225",
    stroke: "black",
    strokeWidth: 2.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeta);
export default __webpack_public_path__ + "static/media/meta.7c6d6329791afc4fcf284cbad91f1812.svg";
export { ForwardRef as ReactComponent };